import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../../styleConstants";

const styles = {
  containerOdd: {
    paddingBottom: "4rem",
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gridTemplateRows: "repeat(4, 1fr)",
    "& :nth-child(1)": {
      gridArea: "1 / 1 / 5 / 3"
    },
    "& :nth-child(2)": {
      gridArea: "1 / 3 / 2 / 8"
    },
    "& :nth-child(3)": {
      gridArea: "2 / 3 / 5 / 8"
    }
  },
  containerEven: {
    paddingBottom: "4rem",
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gridTemplateRows: "repeat(4, 1fr)",
    "& :nth-child(1)": {
      gridArea: "1 / 2 / 5 / 4"
    },
    "& :nth-child(2)": {
      gridArea: "1 / 4 / 2 / 9"
    },
    "& :nth-child(3)": {
      gridArea: "2 / 4 / 5 / 9"
    }
  },
  reference: {
    lineHeight: 0.75,
    fontSize: "15rem",
    fontWeight: styleConstants.fontWeights.bold,
    color: styleConstants.colors.themeBlueMedium,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  title: {
    lineHeight: styleConstants.fonts.headingLineHeight,
    fontSize: "2rem",
    fontWeight: styleConstants.fontWeights.light,
    paddingLeft: "2rem",
    display: "flex",
    alignItems: "flex-end"
  },
  description: {
    padding: "1rem 2rem 0"
  }
};

const ThemeSummary = props => {
  return (
    <div
      className={
        props.shift ? props.classes.containerEven : props.classes.containerOdd
      }
    >
      <div className={props.classes.reference}>{props.reference}</div>
      <div className={props.classes.title}>
        <div>{props.title}</div>
      </div>
      <div className={props.classes.description}>{props.children}</div>
    </div>
  );
};

ThemeSummary.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shift: PropTypes.bool,
  children: PropTypes.string.isRequired
};

ThemeSummary.defaultProps = {
  shift: false
};

export default withStyles(styles)(ThemeSummary);
